import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Challenge() {
  return (
    <section className="challenge_par challenge_selah p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={6} xl={5} xxl={5} className="my-auto">
            <h2>Challenges & Solutions</h2>
            <p>
              The biggest challenge was probably creating a social networking
              platform that stands out from other platforms like Instagram,
              Snapchat, and Facebook. Although the idea was unique, people would
              not buy it if the implementation was not done the right way. Thus,
              we integrated some fantastic features that may not sound such a
              big deal but are unique and currently unavailable on any other
              social networking platform except Selah.
            </p>
            <p>
              Secondly, we showed that the app is only for socializing with
              family and close friends. No irrelevant influencers, fashion
              models, or other out-of-context individuals– only those who matter
              the most!
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-xl-2 offset-lg-1"
          >
            <div className="challenge_img text-center">
              <StaticImage
                src="../../../images/case-studies/selah/tek_img_02.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={616}
                height={650}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Challenge;
